import request from '@/utils/request'
const apiPath = '/sys/sysTask'
const sysTaskApi = {
  /**
   * 新增【任务】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【任务】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【任务】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee', { params: query })
  },
  /**
   * 查询【任务】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【任务】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  downloadMarketingExport(id) {
    return request.get(`${apiPath}/tee/${id}/download`, { responseType: 'blob' })
  },
  /**
   * 删除单个【任务】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【任务】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  }
}
export default sysTaskApi
